import { render, staticRenderFns } from "./deviceItem_page.vue?vue&type=template&id=0ba32e5a&scoped=true"
import script from "./deviceItem_page.vue?vue&type=script&lang=js"
export * from "./deviceItem_page.vue?vue&type=script&lang=js"
import style0 from "./deviceItem_page.vue?vue&type=style&index=0&id=0ba32e5a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba32e5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ba32e5a')) {
      api.createRecord('0ba32e5a', component.options)
    } else {
      api.reload('0ba32e5a', component.options)
    }
    module.hot.accept("./deviceItem_page.vue?vue&type=template&id=0ba32e5a&scoped=true", function () {
      api.rerender('0ba32e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/deviceItem_page.vue"
export default component.exports